export const ConstantRoute = {
    menus: [
        {
            path: 'Dashboard',
            text: 'Dashboard',
            icon: 'dashboard',
            roles: ['superadmin', 'admin', 'subadmin', 'stallowner', 'user', 'so_event_owner']
        },
        {
            path: 'Events',
            text: 'Events',
            icon: 'event',
            roles: ['superadmin']
        },
        {
            path: 'Event Users',
            text: 'Sub-Admins/Volunteers',
            icon: 'group',
            roles: ['superadmin']
        },
        {
            path: 'Users',
            text: 'App Users',
            icon: 'person',
            roles: ['superadmin']
        },
        {
            path: 'stallCatalogues',
            text: 'Stall/Catalogues',
            icon: 'storefront',
            roles: ['superadmin']
        },
        {
            path: 'Event Type',
            text: 'Event Type',
            icon: 'category',
            roles: ['superadmin']
        },
        {
            path: 'Advertise',
            text: 'Advertise',
            icon: 'campaign',
            roles: ['superadmin']
        },
        {
            path: 'Blog',
            text: 'Blog',
            icon: 'edit',
            roles: ['superadmin']
        },
        {
            path: 'Registered Users',
            text: 'Registrations',
            icon: 'how_to_reg',
            roles: ['admin', 'subadmin']
        },
        {
            path: 'Reports',
            text: 'Reports',
            icon: 'bar_chart',
            roles: ['admin', 'subadmin']
        },
        {
            path: 'Transactions',
            text: 'Transactions',
            icon: 'how_to_reg',
            roles: ['admin', 'subadmin']
        },
        {
            path: 'AdminUser',
            text: 'Admins',
            icon: 'admin_panel_settings',
            roles: ['admin', 'subadmin']
        },
        {
            path: 'Artists',
            text: 'Artists',
            icon: 'music_note',
            roles: ['admin', 'subadmin']
        },
        {
            path: 'Sponsor',
            text: 'Sponsor',
            icon: 'paid',
            roles: ['admin', 'subadmin']
        },
        {
            text: 'Settings',
            icon: 'settings',
            roles: ['admin', 'subadmin'],
            children: [
                { path: 'Setting', text: 'Event Settings', icon: 'event_available' },
                { path: 'Scanning Points', text: 'Scanning Settings', icon: 'qr_code_scanner' },
                { path: 'Custom Card', text: 'Card Design', icon: 'style' },
                { path: 'Registration Setting', text: 'Form & Card Fields', icon: 'list_alt' },
                { path: 'Gallery', text: 'Gallery', icon: 'photo_library' },
                { path: 'Payment Setting', text: 'Payment Setting', icon: 'payments', roles: ['admin'] },
                { path: 'Coupon Code', text: 'Coupon Code', icon: 'sell', roles: ['admin'] },
                { path: 'Push Notification', text: 'Push Notification', icon: 'notifications_active' },
            ]
        },
        {
            path: 'Ticket Category',
            text: 'Ticket Category',
            icon: 'confirmation_number',
            roles: ['admin', 'subadmin']
        },
        {
            path: 'Tickets',
            text: 'Tickets',
            icon: 'local_activity',
            roles: ['admin', 'subadmin']
        },
        {
            path: 'Stall',
            text: 'Stall',
            icon: 'storefront',
            roles: ['admin', 'subadmin']
        },
        {
            path: 'My Stall',
            text: 'My Stall',
            icon: 'store',
            roles: ['stallowner', 'so_event_owner']
        },
        {
            path: 'My Catalogue',
            text: 'My Catalogue/Shop',
            icon: 'store',
            roles: ['admin', 'subadmin', 'user', 'so_event_owner']
        },
        {
            path: 'Listings',
            text: 'My Events',
            icon: 'event_note',
            roles: ['admin', 'subadmin']
        },
        {
            path: 'SoEventDetail',
            text: 'Event Details',
            icon: 'event_note',
            roles: ['so_event_owner']
        }
    ]
};
